<template>
  <div>
    <el-upload class="upload-demo" ref="upload" :action="action" :on-preview="handlePreview" :on-remove="handleRemove"
      :file-list="fileList" :auto-upload="false" :limit="1" accept=".xls" :on-success="handleSuccess">
      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
      <div slot="tip" class="el-upload__tip">只能上传后缀为 xls 的 Excel 文件，只允许上传一个文件，且不超过500kb</div>
    </el-upload>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        fileList: []
      };
    },
    props: ["action"], //接受父组件传值
    methods: {
      submitUpload() {
        // 校验是否选取了文件
        // console.log('submitUpload=>'+this.fileList);
        // if (this.fileList.length === 0) {
        //   this.$message.warning('请先选择一个文件！');
        //   return;
        // }

        this.$refs.upload.submit();
      },
      handleRemove(file, fileList) {
        // 移除文件时更新 fileList
        // this.fileList = fileList;
      },
      handlePreview(file) {
      },
      handleSuccess(response, file, fileList) {
        if (response.success) {
          this.$message({
            message: response.msg,
            type: "success"
          });
          // 上传成功后自动移除文件
          this.fileList = [];  // 更新 fileList，移除上传成功的文件
        } else {
          this.$message({
            message: response.msg,
            type: "error"
          });
        }
      }
    }
  }
</script>
